<template>
    <BorrarModalComponent
        :name="'delete-descuento-' + voucher.id"
        title="Eliminar Descuento"
        @confirm="handleConfirm"
        @cancel="handleCancel"
        @close="handleCancel"
    >
        ¿Estás seguro de eliminar el descuento {{ voucher.name }}?
    </BorrarModalComponent>
</template>

<script setup>
    import BorrarModalComponent from '@/modules/admin/ui/BorrarModalComponent.vue';
    import { useEventVouchers } from '@/composables/admin/events/vouchers/useEventVouchers';

    const props = defineProps({
        eventoId: {
            type: [String, Number],
            required: true,
        },
        voucher: {
            type: Object,
            required: true,
        },
    });

    const emit = defineEmits(['close']);

    const { deleteVoucher, closeModal } = useEventVouchers(props.eventoId);

    async function handleConfirm() {
        const success = await deleteVoucher(props.voucher.id);

        if (success) {
            closeModal('delete-descuento-' + props.voucher.id);
            emit('close', 'delete-descuento-' + props.voucher.id);
        }
    }

    function handleCancel() {
        closeModal('delete-descuento-' + props.voucher.id);
    }
</script>
